import { render } from "./Headerbox.vue?vue&type=template&id=41c84e74&scoped=true&ts=true"
import script from "./Headerbox.vue?vue&type=script&lang=ts"
export * from "./Headerbox.vue?vue&type=script&lang=ts"

import "./Headerbox.vue?vue&type=style&index=0&id=41c84e74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c84e74"]])

export default __exports__